"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("./built/pb");

var _object = require("lodash/object");

var _getPrebidPbjs = _interopRequireDefault(require("./getPrebidPbjs"));

var _Bidder = _interopRequireDefault(require("../../utils/Bidder"));

var _BidResponse = _interopRequireDefault(require("../../utils/BidResponse"));

var _logger = _interopRequireDefault(require("../../utils/logger"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Given an ad unit object from the tab-ads config, return the
 * associated Prebid ad unit.
 * @param {Object} tabAdUnit - The tab-ads ad unit.
 * @param {Object} config - The tab-ads config object.
 * @return {Object} A Prebid ad unit config object.
 */


var getPrebidAdUnit = function getPrebidAdUnit(tabAdUnit, config) {
  var _config$newTabAds = config.newTabAds,
      leaderboard = _config$newTabAds.leaderboard,
      rectangleAdPrimary = _config$newTabAds.rectangleAdPrimary,
      rectangleAdSecondary = _config$newTabAds.rectangleAdSecondary;

  switch (tabAdUnit.adId) {
    case leaderboard.adId:
      // Leaderboard-style ad
      return {
        code: tabAdUnit.adId,
        mediaTypes: {
          banner: {
            sizes: tabAdUnit.sizes
          }
        },
        bids: [{
          bidder: 'sonobi',
          params: {
            dom_id: tabAdUnit.adId,
            ad_unit: tabAdUnit.adUnitId
          }
        }, {
          bidder: 'pulsepoint',
          params: {
            cf: '728X90',
            cp: '560174',
            ct: '460981'
          }
        }, {
          bidder: 'aol',
          params: {
            // 'aol' is a built-in alias for One Mobile (Verizon SSP).
            // https://docs.prebid.org/dev-docs/bidders.html#onemobile
            dcn: '8a96954f01747430358b35f958c502f0',
            pos: '8a96954f01747430358b35fa26a402f4'
          }
        }, {
          bidder: 'sovrn',
          params: {
            tagid: '438918'
          }
        }, {
          bidder: 'openx',
          params: {
            unit: '538658529',
            delDomain: 'tabforacause-d.openx.net'
          }
        }, // EMX Digital was formerly brealtime.
        // http://prebid.org/dev-docs/bidders.html#emx_digital
        {
          bidder: 'emx_digital',
          params: {
            tagid: '29672'
          }
        }, {
          bidder: 'rhythmone',
          params: {
            placementId: '73423'
          }
        }]
      };

    case rectangleAdPrimary.adId:
      // Rectangle-style ad
      return {
        code: tabAdUnit.adId,
        mediaTypes: {
          banner: {
            sizes: tabAdUnit.sizes
          }
        },
        bids: [{
          bidder: 'sonobi',
          params: {
            dom_id: tabAdUnit.adId,
            ad_unit: tabAdUnit.adUnitId
          }
        }, {
          bidder: 'pulsepoint',
          params: {
            cf: '300X250',
            cp: '560174',
            ct: '460982'
          }
        }, {
          bidder: 'aol',
          params: {
            dcn: '8a96954f01747430358b35f958c502f0',
            pos: '8a96954f01747430358b35fab61202f5'
          }
        }, {
          bidder: 'sovrn',
          params: {
            tagid: '438916'
          }
        }, {
          bidder: 'openx',
          params: {
            unit: '538658529',
            delDomain: 'tabforacause-d.openx.net'
          }
        }, {
          bidder: 'emx_digital',
          params: {
            tagid: '29673'
          }
        }, {
          bidder: 'rhythmone',
          params: {
            placementId: '73423'
          }
        }]
      };

    case rectangleAdSecondary.adId:
      // Second rectangle-style ad
      return {
        code: tabAdUnit.adId,
        mediaTypes: {
          banner: {
            sizes: tabAdUnit.sizes
          }
        },
        bids: [{
          bidder: 'sonobi',
          params: {
            dom_id: tabAdUnit.adId,
            ad_unit: tabAdUnit.adUnitId
          }
        }, {
          bidder: 'pulsepoint',
          params: {
            cf: '300X250',
            cp: '560174',
            ct: '665497'
          }
        }, {
          bidder: 'aol',
          params: {
            dcn: '8a96954f01747430358b35f958c502f0',
            pos: '8a9690620174743031d835fb5fa90049'
          }
        }, {
          bidder: 'sovrn',
          params: {
            tagid: '589343'
          }
        }, {
          bidder: 'openx',
          params: {
            unit: '538658529',
            delDomain: 'tabforacause-d.openx.net'
          }
        }, // {
        //   bidder: 'emx_digital',
        //   params: {
        //     tagid: 'TODO'
        //   }
        // },
        {
          bidder: 'rhythmone',
          params: {
            placementId: '73423'
          }
        }]
      };

    default:
      return null;
  }
};
/**
 * Given the tab-ads config, return an array of Prebid ad units.
 * @param {Object} config - The tab-ads config object.
 * @return {Array} An array of Prebid ad unit config objects.
 */


var getAdUnits = function getAdUnits(config) {
  var adUnits = config.adUnits;
  var prebidAdUnits = adUnits.map(function (adUnit) {
    return getPrebidAdUnit(adUnit, config);
  });
  return prebidAdUnits.filter(function (adUnit) {
    return !!adUnit;
  });
};
/**
 * Given Prebid bid responses, return an object keyed by ad ID with
 * value an array of BidResponses.
 * @param {Object} rawBidData - Prebid's "bids" object passed to the
 *   bidsBackHandler callback. See:
 *   http://prebid.org/dev-docs/publisher-api-reference.html#module_pbjs.requestBids
 * @return {Object} bidResponses - An object with keys equal to each adId
 *   for which there's a bid and values with an array of BidResponses, the
 *   bidder's normalized bids for that ad.
 */


var normalizeBidResponses = function normalizeBidResponses() {
  var rawBidData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var normalizeBid = function normalizeBid(adId, rawBid) {
    return (0, _BidResponse.default)({
      adId: adId,
      revenue: rawBid.cpm / 1000 || 0,
      advertiserName: rawBid.bidderCode,
      adSize: rawBid.size
    });
  };

  var normalizedBids = Object.keys(rawBidData).reduce(function (accumulator, adId) {
    var rawBidsForAdId = (0, _object.get)(rawBidData, [adId, 'bids'], []);
    return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, adId, rawBidsForAdId.map(function (rawBid) {
      return normalizeBid(adId, rawBid);
    })));
  }, {});
  return normalizedBids;
};

var name = 'prebid';
/**
 * Fetch bids from Prebid partners. Return a Promise that resolves
 * into bid response data when the bids return.
 * See Prebid setup docs here:
 * http://prebid.org/dev-docs/examples/basic-example.html
 * @param {Object} the tab-ads config
 * @return {Promise<Object>} BidResponseData
 * @return {Object} BidResponseData.bidResponses - An object with
 *   keys equal to each adId for which there's a bid and values with
 *   a BidResponse, the bidder's normalized bid for that ad.
 * @return {Object} BidResponseData.rawBidResponses - An object with
 *   keys equal to each adId for which there's a bid and values with
 *   the raw bid response structure (different for each bidder).
 */

var fetchBids =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(config) {
    var tabAdUnits;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _logger.default.debug("Prebid: bids requested");

            tabAdUnits = config.adUnits;

            if (tabAdUnits.length) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.resolve({
              bidResponses: {},
              rawBidResponses: {}
            }));

          case 4:
            return _context.abrupt("return", new Promise(function (resolve) {
              function handleAuctionEnd(rawBids) {
                _logger.default.debug("Prebid: auction ended");

                resolve({
                  bidResponses: normalizeBidResponses(rawBids),
                  rawBidResponses: rawBids
                });
              }

              var adUnits = getAdUnits(config);
              var pbjs = (0, _getPrebidPbjs.default)();
              pbjs.que.push(function () {
                pbjs.setConfig(_objectSpread({
                  debug: config.logLevel === 'debug',
                  // bidderTimeout: 700 // default
                  publisherDomain: config.publisher.domain,
                  // Used for SafeFrame creative
                  // Overrides the page URL adapters should use. Otherwise, some adapters
                  // will use the current frame's URL while others use the top frame URL.
                  // Only some adapters use this setting as of May 2018.
                  // https://github.com/prebid/Prebid.js/issues/1882
                  pageUrl: config.publisher.pageUrl
                }, config.consent.enabled && {
                  consentManagement: {
                    gdpr: {
                      cmpApi: 'iab',
                      timeout: config.consent.timeout,
                      // If the CMP does not respond in time, gdprApplies
                      // is false.
                      defaultGdprScope: false
                    },
                    usp: {
                      cmpApi: 'iab',
                      timeout: config.consent.timeout
                    }
                  }
                }));
                pbjs.addAdUnits(adUnits);
                pbjs.requestBids({
                  bidsBackHandler: handleAuctionEnd
                });
              });
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchBids(_x) {
    return _ref.apply(this, arguments);
  };
}();

var setTargeting = function setTargeting() {
  var pbjs = (0, _getPrebidPbjs.default)();
  pbjs.setTargetingForGPTAsync();

  _logger.default.debug("Prebid: set ad server targeting");
};

var PrebidBidder = (0, _Bidder.default)({
  name: name,
  fetchBids: fetchBids,
  setTargeting: setTargeting
});
var _default = PrebidBidder;
exports.default = _default;